'use client';

import { useState } from 'react';

import { cn } from '@/lib';
import type { Place, SelectOption } from '@/types';

import { useEvents } from '@/lib/hooks/use-events';

import { EventSearchActionBar } from './event-search-action-bar';
import { EventSearchCalendar } from './event-search-calendar';
import { EventSearchCarousel } from './event-search-carousel';
import { EventSearchTimeline } from './event-search-timeline';

export interface EventSearchProps {
  placesData: Place[] | undefined;
  views: SelectOption[];
  filters: SelectOption[];
  className?: string;
}

export function EventSearch({ placesData, views, filters: availableFilters, className }: EventSearchProps) {
  const [view, setView] = useState(views?.[0]?.value || 'timeline');
  const eventsData = useEvents(placesData);
  const showActionBar = Boolean(availableFilters?.length) || views?.length > 1;

  return (
    <div className={cn('flex w-full flex-col items-center gap-8 sm:gap-16', className)}>
      {showActionBar && (
        <EventSearchActionBar
          placesData={placesData}
          views={views}
          view={view}
          setView={setView}
          availableFilters={availableFilters}
          eventsData={eventsData}
        />
      )}

      {view === 'timeline' && <EventSearchTimeline placesData={placesData} eventsData={eventsData} />}

      {view === 'calendar' && <EventSearchCalendar placesData={placesData} eventsData={eventsData} />}

      {view.includes('carousel') && (
        <EventSearchCarousel
          placesData={placesData}
          eventsData={eventsData}
          cardSize={view === 'carousel-large' ? 'lg' : 'sm'}
        />
      )}
    </div>
  );
}
